var _path, _path2, _path3, _path4, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1055 1C15.8084 1.00015 16.374 1.56657 16.374 2.26953C16.3738 2.97235 15.8083 3.53794 15.1055 3.53809H4.58398C4.0059 3.53832 3.5383 4.00595 3.53809 4.58398V15.1045C3.53809 15.8074 2.97241 16.3739 2.26953 16.374C1.5665 16.374 1 15.8075 1 15.1045V4.58398C1.00021 2.60522 2.60523 1.00024 4.58398 1H15.1055Z",
    fill: "#6466E9",
    stroke: "#6466E9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39941 57.6328C3.04083 57.6976 3.53809 58.2364 3.53809 58.8955V69.416C3.53823 69.9941 4.00586 70.4617 4.58398 70.4619H15.1055C15.8082 70.4621 16.3738 71.0277 16.374 71.7305C16.374 72.4334 15.8084 72.9999 15.1055 73H4.58398C2.60519 72.9998 1.00014 71.3948 1 69.416V58.8955L1.00684 58.7646C1.07182 58.1234 1.6106 57.626 2.26953 57.626L2.39941 57.6328Z",
    fill: "#6466E9",
    stroke: "#6466E9",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.415 1C71.394 1.00003 72.9988 2.60509 72.999 4.58398V15.1045C72.999 15.8075 72.4334 16.3739 71.7305 16.374C71.0274 16.374 70.4609 15.8075 70.4609 15.1045V4.58398C70.4607 4.00582 69.9933 3.53812 69.415 3.53809H58.8945C58.2355 3.53809 57.6967 3.04086 57.6318 2.39941L57.625 2.26953L57.6318 2.13867C57.6968 1.49739 58.2356 1 58.8945 1H69.415Z",
    fill: "#6466E9",
    stroke: "#6466E9",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8604 57.6328C72.5018 57.6976 72.999 58.2364 72.999 58.8955V69.416C72.9989 71.395 71.394 73 69.415 73H58.8945C58.1915 73 57.625 72.4335 57.625 71.7305C57.6252 71.0276 58.1917 70.4619 58.8945 70.4619H69.415C69.9916 70.4619 70.4608 69.9906 70.4609 69.416V58.8955C70.4609 58.1924 71.0274 57.626 71.7305 57.626L71.8604 57.6328Z",
    fill: "#6466E9",
    stroke: "#6466E9",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 16.3501,
    width: 49.0008,
    height: 41.9998,
    rx: 4,
    fill: "#E4EDF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.60156,
    y: 33.8501,
    width: 58.801,
    height: 6.99997,
    rx: 3.49999,
    fill: "#19F294"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanLarge);
export default __webpack_public_path__ + "static/media/scan-large.ed67f093.svg";
export { ForwardRef as ReactComponent };